import axios from 'axios';
import EnvironmentUtils from '../utils/environment-utils';
import {
  applyAuthTokenInterceptor,
  applyPendingRequestCountInterceptor,
  applyTokenExpirationInterceptor,
} from './axios-interceptors';

const CoreApiClient = axios.create({
  baseURL: EnvironmentUtils.getVar('CORE_API'),
});

applyAuthTokenInterceptor(CoreApiClient);
applyPendingRequestCountInterceptor(CoreApiClient);
applyTokenExpirationInterceptor(CoreApiClient);

export default CoreApiClient;
